import { render } from "./ConformeNaoConformeSelect.vue?vue&type=template&id=6f6d820b"
import script from "./ConformeNaoConformeSelect.vue?vue&type=script&lang=js"
export * from "./ConformeNaoConformeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__